import axios from "axios";
import ErrorParser from '../../../helpers/services/error.parser';

const ExceedanceDescriptionsService = {
  exceedancedescriptions: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/exceedance_descriptions",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  exceedingmethods: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/exceeding_methods",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },  
  delete: async function (id) {
    const requestData = {
      method: "post",
      url: "/api/management/exceedance_descriptions/delete",
      data: { id: id }
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  update: async function (ed) {
    const requestData = {
      method: "post",
      url: "/api/management/exceedance_descriptions/update",
      data: ed
    };
    try {
      // debugger
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },  
  deleteMethod: async function (exceedingmethods) {
    const requestData = {
      method: "post",
      url: "/api/management/exceeding_methods/delete",
      data: exceedingmethods
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },     
  updateMethod: async function (ed) {
    const requestData = {
      method: "post",
      url: "/api/management/exceeding_methods/update",
      data: ed
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },   
  import: async function (formData) {
    const requestData = {
      method: "post",
      url: "/imports/exceedance_descriptions",
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  importMethods: async function (formData) {
    const requestData = {
      method: "post",
      url: "/imports/exceeding_methods",
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  exceedancedescription: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/exceedance_descriptions/ed",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  exceedancetype: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/exceedance_descriptions/et",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  areaclassifications: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/exceedance_descriptions/ac",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  adjustmenttypes: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/exceedance_descriptions/at",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  attainments: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/exceedance_descriptions/att",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  exceedancereason: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/exceedance_descriptions/er",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  }
};

export default ExceedanceDescriptionsService;
